import CSATResearch from './CSATResearch/pt-BR';

export default {
  ...CSATResearch,
};
